module.exports = "https://static.cdns.space/tarot-temp/img/the-tower.1fcea3c3.webp";